const API_BASE = 'https://api.gewo.health/api/resources';

export const getPlaceholderImage = (width = 400, height = 220, text = 'No Image') => {
  const svg = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" fill="#F4F6F8"/><text x="50%" y="50%" font-family="Arial, sans-serif" font-size="16" fill="#8F9BA8" text-anchor="middle" dominant-baseline="middle">${text}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

const mapArticleFromAPI = (apiArticle) => {
  const featuredImage = apiArticle.featuredImage;
  const hasValidImage = featuredImage && 
    typeof featuredImage === 'string' && 
    featuredImage.trim().length > 0 && 
    (featuredImage.startsWith('http://') || featuredImage.startsWith('https://') || featuredImage.startsWith('data:'));
  
  return {
    id: apiArticle._id,
    slug: apiArticle.slug,
    title: apiArticle.title,
    category: apiArticle.category,
    author: apiArticle.author?.name || 'Unknown Author',
    authorTitle: apiArticle.author?.title || '',
    excerpt: apiArticle.description || '',
    image: hasValidImage ? featuredImage : getPlaceholderImage(400, 220, 'Article Image'),
    readTime: `${apiArticle.readingTime || 5} min read`,
    date: apiArticle.publishedAt ? new Date(apiArticle.publishedAt).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
    content: apiArticle.content || ''
  };
};

export const fetchArticles = async (params = {}) => {
  try {
    const { page = 1, limit = 10, category, search } = params;
    
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    
    if (category && category !== 'All') {
      queryParams.append('category', category);
    }
    
    if (search) {
      queryParams.append('search', search);
    }
    
    const url = `${API_BASE}?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Articles not found');
      }
      throw new Error(`Failed to fetch articles: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch articles');
    }
    
    return {
      articles: data.data.resources.map(mapArticleFromAPI),
      pagination: data.data.pagination || {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
      }
    };
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

export const fetchArticleBySlug = async (slug) => {
  try {
    const url = `${API_BASE}/${slug}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Article not found');
      }
      throw new Error(`Failed to fetch article: ${response.statusText}`);
    }
    
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch article');
    }
    
    return mapArticleFromAPI(data.data);
  } catch (error) {
    console.error('Error fetching article:', error);
    throw error;
  }
};
